export const APP_NAME = 'Dpanda Internal Tools'
export const COMPANY_NAME = 'Dpanda Internal Tools'
export const PERSIST_STORE_NAME = 'dpit-token'
export const REDIRECT_URL_KEY = 'redirectUrl'